import {
  BlockUI,
  NgBlockUI
}                           from 'ng-block-ui';
import {
  Component,
  EventEmitter,
  Input,
  Output
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


import { HaynesProLaborOptionModel } from './typings/haynes-pro.labor-option';
import { HaynesProLaborTimeModel }   from './typings/haynes-pro.labor-time';
import {
  HaynesProMaintenancePartGroup,
  HaynesProMaintenancePart
}                                    from './typings/haynes-pro.maintenance-part';
import { HaynesProService }          from './haynes-pro.service';
import { Table }                     from '../table/types/table';

@Component({
  styles: [require('./haynes-pro.maintenance-times.row.expanded.component.scss')],
  template: require('./haynes-pro.maintenance-times.row.expanded.component.html')
})

export class HaynesProMaintenanceTimesExpandedRowComponent {
  public laborTimes                    = [];
  public laborIncludedSettings : Table = {
    columns: [
      {
        field : 'name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
        }
      }
    ],
    pagination: {
      enabled: false
    },
    static: true
  };

  public maintenancePartsSettings : Table = {
    columns: [
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'remark',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REMARK')
        }
      }
    ],
    pagination: {
      enabled: false
    },
    static: true
  };

  public maintenancePartsCollapsed                             = true;
  public selectedMaintenanceParts : HaynesProMaintenancePart[] =[];

  @BlockUI('haynesProMaintenanceTimesRowExpandedBlock') block : NgBlockUI;

  @Input() record          : any;
  @Input() rowExpansionData: any;
  @Input() viewMode        : boolean;

  @Output() onTimeAdd      : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();
  @Output() onTimeRemove   : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();

  constructor (
    private haynesProService: HaynesProService,
    public translateService : TranslateService
  ) {}

  get laborOptions () : any[] {
    return this.record?.__laborOptions || [];
  }

  get laborTimesIncluded () : any[] {
    return this.record?.__laborTimesIncluded || [];
  }

  get maintenanceParts () : HaynesProMaintenancePartGroup[] {
    return this.record?.___maintenanceParts || [];
  }

  handleLaborOptionSelection ( option : HaynesProLaborOptionModel ) : void {
    this.block.start();
    this.laborTimes = [];

    setTimeout(() => {
      this.laborTimes = this.haynesProService.removeTimesWithNoLabor(option.tasks);
      this.block.stop();
    }, 500);
  }

  handleMaintenancePartsSelection ( option : HaynesProMaintenancePartGroup ) : void {
    this.maintenanceParts.forEach(item => item.selected = false);

    if (option) {
      option.selected = true;
    }

    this.selectedMaintenanceParts = option?.parts || [];
  }

  ngOnInit () : void {
    if (typeof this.rowExpansionData === 'function') {
      this.rowExpansionData(this.record);
    }
  }

  toggleMaintenanceParts () : void {
    this.maintenancePartsCollapsed = !this.maintenancePartsCollapsed;

    if (!this.maintenancePartsCollapsed && this.maintenanceParts?.length) {
      const selectedOption = this.maintenanceParts.find(option => option.selected);

      if (!selectedOption) {
        this.handleMaintenancePartsSelection(this.maintenanceParts[0]);
      }
    } else {
      this.selectedMaintenanceParts = [];
    }
  }

}